import styled from "styled-components";

export const Box = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }

  body {
    font-family: system-ui, -apple-system, sans-serif;
  }
  body {
    // font-family: system-ui, -apple-system, sans-serif;
    background-color: rgb(249, 250, 251);
    min-height: 100vh;
    padding: 2rem 1rem;
  }

  .container-jpg-png {
    max-width: 64rem;
    margin: 0 auto;
  }

  .container-jpg-png .converter {
    background-color: white;
    border-radius: 0.75rem;
    padding: 2rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .container-jpg-png .title {
    font-size: 1.5rem;
    font-weight: 700;
    color: rgb(17, 24, 39);
    margin-bottom: 0.25rem;
  }

  .container-jpg-png .description {
    color: rgb(75, 85, 99);
    margin-bottom: 0.5rem;
  }

  .container-jpg-png .format-info {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 2rem;
    flex-wrap: wrap;
  }

  .container-jpg-png .badge {
    background-color: rgb(243, 244, 246);
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    color: rgb(75, 85, 99);
  }

  .container-jpg-png .dropzone {
    border: 2px dashed rgb(209, 213, 219);
    border-radius: 0.5rem;
    padding: 2rem;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.2s;
  }

  .container-jpg-png .dropzone:hover {
    border-color: rgb(59, 130, 246);
  }

  .container-jpg-png .dropzone-icon {
    width: 3rem;
    height: 3rem;
    margin: 0 auto 0.5rem;
    color: rgb(156, 163, 175);
  }

  .container-jpg-png .dropzone-text {
    color: rgb(75, 85, 99);
    font-size: 0.875rem;
    margin-bottom: 0.25rem;
  }

  .container-jpg-png .dropzone-hint {
    color: rgb(107, 114, 128);
    font-size: 0.75rem;
  }

  .container-jpg-png .preview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 1rem;
    margin-top: 2rem;
  }

  .container-jpg-png .preview-item {
    position: relative;
    border-radius: 0.5rem;
    overflow: hidden;
  }

  .container-jpg-png .preview-image {
    width: 100%;
    height: 8rem;
    object-fit: cover;
  }

  .container-jpg-png .preview-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 0.875rem;
    opacity: 0;
    transition: opacity 0.2s;
  }

  .container-jpg-png .preview-item:hover .preview-overlay {
    opacity: 1;
  }

  .container-jpg-png .buttons {
    display: flex;
    gap: 1rem;
    margin-top: 1.5rem;
  }

  .container-jpg-png .button {
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .container-jpg-png .button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .container-jpg-png .button-primary {
    background-color: rgb(37, 99, 235);
    color: white;
  }

  .container-jpg-png .button-primary:hover:not(:disabled) {
    background-color: rgb(29, 78, 216);
  }

  .container-jpg-png .button-success {
    background-color: rgb(22, 163, 74);
    color: white;
  }

  .container-jpg-png .button-success:hover {
    background-color: rgb(21, 128, 61);
  }

  .container-jpg-png .hidden {
    display: none;
  }

  @media (max-width: 768px) {
    body {
      padding: 1rem 0.5rem;
    }

    .container-jpg-png .converter {
      padding: 1.5rem;
      border-radius: 0.5rem;
    }

    .container-jpg-png .format-info {
      flex-direction: column;
      gap: 0.5rem;
      margin-bottom: 1.5rem;
    }

    .container-jpg-png .dropzone {
      padding: 1.5rem;
      border-width: 3px; /* Thicker border for better visibility */
    }

    .container-jpg-png .dropzone-icon {
      width: 2.5rem;
      height: 2.5rem;
    }

    .container-jpg-png .dropzone-text {
      font-size: 1rem; /* Slightly larger for readability */
      font-weight: 500;
    }

    .container-jpg-png .dropzone-hint {
      font-size: 0.85rem;
    }

    .container-jpg-png .preview-grid {
      grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
      gap: 0.75rem;
      max-height: 50vh; /* Limit height to prevent overflow */
      overflow-y: auto; /* Scrollable preview area */
      padding: 0.5rem;
    }

    .container-jpg-png .preview-image {
      height: 6rem; /* Smaller images for mobile */
    }

    .container-jpg-png .buttons {
      flex-direction: column;
      gap: 0.75rem;
    }

    .container-jpg-png .button {
      padding: 0.75rem; /* Larger padding for touch */
      font-size: 1rem;
      min-height: 44px; /* Minimum touch target size */
      justify-content: center;
    }
  }

  @media (max-width: 480px) {
    .container-jpg-png .converter {
      padding: 1rem;
    }

    .container-jpg-png .title {
      font-size: 1.25rem; /* Smaller title for small screens */
    }

    .container-jpg-png .description {
      font-size: 0.875rem;
    }

    .container-jpg-png .format-info {
      gap: 0.3rem;
    }

    .container-jpg-png .badge {
      font-size: 0.8rem;
      padding: 0.2rem 0.4rem;
    }

    .container-jpg-png .dropzone {
      padding: 1rem;
    }

    .container-jpg-png .dropzone-text {
      font-size: 0.9rem;
    }

    .container-jpg-png .dropzone-hint {
      font-size: 0.75rem;
    }

    .container-jpg-png .preview-grid {
      grid-template-columns: 1fr; /* Single column for very small screens */
      gap: 0.5rem;
    }

    .container-jpg-png .preview-image {
      height: 5rem;
    }

    .container-jpg-png .preview-overlay {
      font-size: 0.8rem;
    }
  }
`;
